<template>
  <div class="search-container">
    <el-form label-width="88px" inline>
      <el-form-item label="类型">
        <el-select v-model="queryParam.businessType" clearable>
          <el-option v-for="item in businessTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker v-model="dateRange" clearable :editable="false"
                        value-format="YYYY-MM"
                        type="monthrange" range-separator="至"
                        start-placeholder="开始时间" end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="getList(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="18">
          <div class="table-title"><span></span>订单列表</div>
        </el-col>
        <el-col :span="6">
          <div class="table-button-container">
            <el-button type="success" @click="showGenerate()">
              <el-icon><plus /></el-icon>新建报表
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="data" border>
      <el-table-column type="index" label="序号" width="58"></el-table-column>
      <el-table-column label="时间">
        <template #default="scope">
          {{scope.row.startDate}} 至 {{scope.row.endDate}}
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="类型">
        <template #default="scope">
          {{scope.row.businessType === 0 ? "蓝酷养车加盟" : scope.row.businessType === 1 ? "蓝酷养车抖音认证" : scope.row.businessType === 2 ? "AUI渠道" : scope.row.businessType === 3 ? "薛神驾到" : "未知"}}
        </template>
      </el-table-column>
      <el-table-column label="收入">
        <template #default="scope">￥{{scope.row.orderAmount}}</template>
      </el-table-column>
      <el-table-column label="成本">
        <template #default="scope">￥{{scope.row.orderCost}}</template>
      </el-table-column>
      <el-table-column label="毛利">
        <template #default="scope">￥{{scope.row.orderBenefit}}</template>
      </el-table-column>
      <el-table-column label="毛利率">
        <template #default="scope">{{scope.row.orderBenefitRate}}%</template>
      </el-table-column>
      <el-table-column label="税点">
        <template #default="scope">￥{{scope.row.orderTax}}</template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template #default="scope">
          <el-link type="primary" :href="scope.row.excelAddress" target="_blank">下载明细</el-link>
          <el-link type="primary" v-if="scope.row.businessType === 2 || scope.row.businessType === 3" @click="generate(scope.row)">刷新</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="queryParam.pageIndex" @size-change="handleSizeChange"
                   :page-size="queryParam.pageSize" :total="queryParam.total" :page-sizes="pageSizes" prev-text="上一页" next-text="下一页"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="新建报表"
             v-model="saveVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form label-width="138px">
      <el-form-item label="类型">
        <el-select v-model="param.businessType">
          <el-option v-for="item in businessTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker v-model="param.dateRange" :editable="false"
                        value-format="YYYY-MM"
                        type="monthrange" range-separator="至"
        />
      </el-form-item>
      <el-button type="primary" @click="generate()">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "报表",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      dateRange: [],
      queryParam: {
        total: 0,
        pageIndex: 1,
        pageSize: 10
      },
      data: [],
      businessTypes: [],
      saveVisible: false,
      param: {}
    }
  },
  methods: {
    getList(pageIndex) {
      if (pageIndex) {
        this.queryParam.pageIndex = pageIndex;
      }
      const params = {
        pageIdx: this.queryParam.pageIndex - 1,
        pageSize: this.queryParam.pageSize,
        businessType: this.queryParam.businessType
      }
      if (this.dateRange.value && this.dateRange.value.length) {
        params.startDate = this.dateRange.value[0];
        params.endDate = this.dateRange.value[1];
      } else {
        params.startDate = null;
        params.endDate = null;
      }
      this.$apis.orderReport.list(params).then(response => {
        this.queryParam.total = response.data.total;
        this.data = response.data.data;
      })
    },
    handleCurrentChange(pageIndex) {
      this.queryParam.pageIndex = pageIndex;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.queryParam.pageSize = pageSize;
      this.getList(1);
    },
    showGenerate() {
      this.param = {};
      this.saveVisible = true;
    },
    generate(source) {
      let param;
      if (source) {
        param = {
          businessType: source.businessType,
          startDate: source.startDate,
          endDate: source.endDate
        }
        this.$confirm('确认重新生成【' + source.startDate + ' - ' + source.endDate + '】的数据？', '刷新',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          this.$apis.orderReport.generateReport(param).then(response => {
            if (response.status === 200) {
              this.$message({
                message: '新建成功',
                type: 'success'
              })
              this.getList();
            }
          })
        }).catch(() => {

        })
      } else {
        param = this.param;
        if (param.businessType == null) {
          this.$message.error('请选择类型');
          return;
        }
        if (!param.dateRange || !param.dateRange.length) {
          this.$message.error('请选择时间');
          return;
        }
        param.startDate = param.dateRange[0];
        param.endDate = param.dateRange[1];
        this.$apis.orderReport.generateReport(param).then(response => {
          if (response.status === 200) {
            this.$message({
              message: '新建成功',
              type: 'success'
            })
            this.getList();
            this.saveVisible = false;
          }
        })
      }
    },
    getBusinessTypes() {
      this.$apis.orderReport.getBusinessTypes().then(response => {
        this.businessTypes = response.data;
      })
    }
  },
  created() {
    this.getBusinessTypes();
    this.getList();
  }
}
</script>

<style scoped>

</style>